<template>

    <v-dialog v-model="dokumentomokDialogVisible" persistent width="900px">

        <v-card>

            <v-card-title>

                <h1 class="headline">Biztosításhoz tartozó dokumentumok</h1>

            </v-card-title>

            <v-card-text>

                <v-spacer />

                    <v-flex v-for="dok in getDokList" :key="getDokList.indexOf(dok)">

                        <v-layout row justify-space-between>

                            <v-flex md10 class="title">

                                {{ dok.codename }}

                            </v-flex>

                            <v-flex md2>

                                <v-icon @click="getFile(dok.dokumentum_feltolt_id)"> file_copy </v-icon>

                            </v-flex>

                        </v-layout>

                        <v-spacer />

                    </v-flex>

            </v-card-text>

            <v-card-actions>

                <v-btn class="button" @click="close()">Mégse</v-btn>

            </v-card-actions>

        </v-card>

    </v-dialog>

</template>

<script>
export default {
    computed: {
        dokumentomokDialogVisible() {
            return this.$store.getters.isDokDialogVisible;
        },
        getDokList() {
            return this.$store.getters.getAllDocs;
        },
    },
    methods: {
        close() {
            this.$store.commit('closeDokDialog');
        },
        getFile(id) {
            this.$store.dispatch('getDocById', id);
        },
    },
};
</script>
